import axios from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import Config from "../Config";

const useDeleteMutation = ({
    endpoint,
    token,
    closeModal,
    refetch,
    successMessage = "Deleted successfully",
    errorMessage = "An error occurred",
    onSuccessCallback,
    onErrorCallback,
}) => {

    const deleteFunction = async (values) => {

        const response = await axios.post(
            `${Config.apiUrl}/${endpoint}`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    };

    return useMutation(deleteFunction, {

        onSuccess: (data) => {

            if (data?.isSuccess === true) {
                toast.success(data?.msg || successMessage);
                closeModal?.();
                refetch?.();
                onSuccessCallback?.(data);
            } else {
                toast.error(data?.msg || errorMessage);
            }
        },

        onError: (error) => {
            toast.error(
                error?.response?.data?.msg || errorMessage
            );
            closeModal?.();
            onErrorCallback?.(error);
        },
    });
};

export default useDeleteMutation;